<template>
  <div>
    <div class="shop-products-img-loader" v-if="imgLoader == 1">
        <div class="lds-dual-ring-media"></div>
    </div>
  <div class="lb" v-if="items.length > 0">
    <div
      class="lb-grid"
      :class="[
        css,
        items.length > cells ? 'lb-grid-' + cells : 'lb-grid-' + items.length,
      ]"
    >
      <div
        class="lb-item"
        v-for="(src, i) in items"
        v-bind:key="i"
        @click="show(i)"
        :style="bg(API_URL + src.image)"
        ref="divItem"
      >
        <span class="lb-more" v-if="i == cells - 1 && items.length - cells > 0"
          >{{ items.length - cells }}+</span
        >
      </div>
    </div>

    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="lb-modal" v-if="index >= 0">
        <button
          class="close-icon btn btn-outline-danger btn-sm lb-modal-close"
          @click="close"
        >
          <i class="fa fa-times"></i>
        </button>
        <button class="btn btn-outline-primary lb-modal-prev" @click="prev">
          <i class="fa fa-angle-left fa-2x"></i>
        </button>
        <button class="btn btn-outline-primary lb-modal-next" @click="next">
          <i class="fa fa-angle-right fa-2x"></i>
        </button>

        <div class="lb-modal-img" @click="close">
          <img :src="src" />
          <div class="spinner spinner-dots-wave" v-if="loading">
            <span class="badge badge-primary rounded-circle w-10 h-10">
              <i class="sr-only">&nbsp;</i>
            </span>
            <span class="badge badge-primary rounded-circle w-10 h-10">
              <i class="sr-only">&nbsp;</i>
            </span>
            <span class="badge badge-primary rounded-circle w-10 h-10">
              <i class="sr-only">&nbsp;</i>
            </span>
            <span class="badge badge-primary rounded-circle w-10 h-10">
              <i class="sr-only">&nbsp;</i>
            </span>
            <span class="badge badge-primary rounded-circle w-10 h-10">
              <i class="sr-only">&nbsp;</i>
            </span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },

    css: {
      type: String,
      default: () => "h-250 h-md-400 h-lg-600",
    },

    cells: {
      type: Number,
      default: () => 5,
    },
  },

  data() {
    return {
      src: "",
      index: -1,
      loading: false,
      API_URL: this.$postStorageURL,
      events: [],
      imgLoader: 1,
    };
  },

  methods: {
    onBackgroundImageLoad() {
      this.imgLoader = 0;
    },
    bind() {
      if (this.events.length > 0) return;

      this.events.push([
        "keydown",
        (e) => {
          if (this.index < 0) return;
          if (e.keyCode === 37) {
            this.prev();
          } else if (e.keyCode === 39) {
            this.next();
          } else if (e.keyCode === 27) {
            this.close();
          }
        },
      ]);
      this.events.forEach((e) => {
        window.addEventListener(e[0], e[1]);
      });
    },

    show(i) {
      if (i >= this.items.length) {
        i = 0;
      }
      if (i < 0) {
        i = this.items.length - 1;
      }
      this.loading = true;
      this.bind();
      this.index = i;
      var src = this.API_URL + this.items[i].image;
      var img = new Image();
      img.src = src;
      img.onload = () => {
        this.loading = false;
        this.src = src;
      };
      // document.querySelector("body").style.overflow = "hidden";
    },
    next() {
      this.show(this.index + 1);
    },

    prev() {
      this.show(this.index - 1);
    },
    close() {
      this.index = -1;
      this.events.forEach((e) => {
        window.removeEventListener(e[0], e[1]);
      });
      this.events = [];
      // document.querySelector("body").style.overflow = "visible";
    },
    bg(i) {
      return i && i.length > 0 ? `background-image: url('${i}')` : "";
    },
  },
  watch: {
  items: {
    handler(newItems) {
      if (newItems.length === 0) {
        this.imgLoader = 0; // Stop loader when items length is zero
        return;
      }
      const images = newItems.map((item) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(item.image);
          img.src = this.API_URL + item.image;
        });
      });

      Promise.all(images).then(() => {
        this.onBackgroundImageLoad();
      });
    },
    deep: true,
    immediate: true 
  },
},
  mounted() {
    this.$nextTick(() => {
      const divItems = this.$refs.divItem;
      if (Array.isArray(divItems)) {
        // If there are multiple div items
        divItems.forEach((div) => {
          const image = new Image();
          image.onload = this.onBackgroundImageLoad;
          image.src = div.style.backgroundImage.slice(4, -1).replace(/"/g, "");
        });
      } else {
        // If there is a single div item
        const image = new Image();
        image.onload = this.onBackgroundImageLoad;
        // image.src = divItems.style.backgroundImage.slice(4, -1).replace(/"/g, "");
      }
    });
  },
};
</script>
<style scoped src="../../assets/css/morioh.min.css">
.post-view {
  background-color: #fff;
  padding: 15px 20px;
  border-radius: 5px;
  position: relative;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 2px 0 rgba(0, 0, 0, 0.19);
}
.post-images {
  width: 100%;
}

.user-info {
  display: flex;
  align-items: center;
}
.user-info img {
  width: 50px;
  object-fit: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-details {
  margin-left: 20px;
}
.user-details p {
  font-size: 0.5rem;
}
.post-images img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.post-images img:first-child {
  width: auto;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 5px;
  margin: 5px 0;
}
.post-images img:nth-child(2),
.post-images img:nth-child(3) {
  display: inline-block;
  height: 100px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 5px;
  margin: 0 0 0 5px;
}
.comments p {
  padding: 5px 0;
  margin: 0;
}
.lb-grid {
  position: relative;
  display: block;
}

.lb-item {
  position: absolute;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-top: solid 2px #fff;
  border-right: solid 2px #fff;
  cursor: pointer;
}

.lb-grid-1 .lb-item {
  width: 100%;
  height: 100%;
}

.lb-grid-2 .lb-item,
.lb-grid-3 .lb-item,
.lb-grid-4 .lb-item,
.lb-grid-5 .lb-item {
  width: 50%;
}

.lb-grid-2 .lb-item,
.lb-grid-3 .lb-item:nth-child(1),
.lb-grid-4 .lb-item:nth-child(1) {
  height: 100%;
}

.lb-grid-3 .lb-item:nth-child(2),
.lb-grid-3 .lb-item:nth-child(3),
.lb-grid-5 .lb-item:nth-child(1),
.lb-grid-5 .lb-item:nth-child(2) {
  height: 50%;
}

.lb-item:last-child,
.lb-grid-2 .lb-item:nth-child(2),
.lb-grid-3 .lb-item:nth-child(2),
.lb-grid-3 .lb-item:nth-child(3),
.lb-grid-4 .lb-item:nth-child(2),
.lb-grid-4 .lb-item:nth-child(3),
.lb-grid-4 .lb-item:nth-child(4),
.lb-grid-5 .lb-item:nth-child(3),
.lb-grid-5 .lb-item:nth-child(4),
.lb-grid-5 .lb-item:nth-child(5) {
  left: auto;
  right: 0;
  border-right: 0;
}

.lb-grid-3 .lb-item:nth-child(3),
.lb-grid-4 .lb-item:nth-child(4),
.lb-grid-5 .lb-item:nth-child(2),
.lb-grid-5 .lb-item:nth-child(5) {
  bottom: 0;
  top: auto;
}

.lb-grid-4 .lb-item:nth-child(3),
.lb-grid-5 .lb-item:nth-child(4) {
  top: 33.333333333333336%;
}

.lb-grid-4 .lb-item:nth-child(2),
.lb-grid-4 .lb-item:nth-child(3),
.lb-grid-4 .lb-item:nth-child(4),
.lb-grid-5 .lb-item:nth-child(3),
.lb-grid-5 .lb-item:nth-child(4),
.lb-grid-5 .lb-item:nth-child(5) {
  height: 33.333333333333336%;
}

.lb-more {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  color: #fff;
  font-size: 3rem;
  background-color: rgba(0, 0, 0, 0.4);
}

.lb-more:before {
  display: inline-block;
  content: "";
  vertical-align: middle;
  height: 100%;
}

/* 
  .lb-more:after{
      position: absolute;
      top: 0;
      left: 0;
      left: 0;
      right: 0;
      z-index: -1;   
      content: "";
      background: #222;
      opacity: 0.9;
  } */

.lb-modal {
  transition: opacity 0.2s ease;
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  min-height: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: block;
  -webkit-user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.lb-modal-close {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #fff;
}

.lb-modal-next,
.lb-modal-prev {
  position: absolute;
  top: 50%;
  left: 20px;
  margin-top: -25px;
  /* width: 50px;
      height: 50px; */
  z-index: 999;
  cursor: pointer;
  color: #fff;
  background-color: transparent;
  border: none;
}

.lb-modal-next {
  left: auto;
  right: 20px;
}

.lb-modal-img {
  position: absolute;
  top: 10px;
  left: 70px;
  right: 70px;
  bottom: 10px;
  text-align: center;
}

.lb-modal-img:before {
  display: inline-block;
  content: "";
  vertical-align: middle;
  height: 100%;
}

.lb-modal-img img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  object-fit: contain;
}

.lb-modal-img .spinner {
  width: 150px;
  position: absolute;
  margin-left: -75px;
  top: 50%;
  left: 50%;
  z-index: 1;
}
</style>